export const NO_DESKTOP = 991;

export const isNoDesktop = () => window.innerWidth <= NO_DESKTOP;
